import { Action, action } from 'easy-peasy';
import { AccountRole, AccountType } from '@/api/types';

export interface UserStore {
    role?: AccountRole | null;
    accountType?: AccountType | null;
    token?: string | null;
    setToken: Action<UserStore, string | null | undefined>;
    setRole: Action<UserStore, AccountRole | null | undefined>;
    setAccountType: Action<UserStore, AccountType | null | undefined>;
}

const user: UserStore = {
    token: undefined,
    role: undefined,
    setToken: action((state, payload) => {
        state.token = payload;
    }),
    setRole: action((state, payload) => {
        state.role = payload;
    }),
    setAccountType: action((state, payload) => {
        state.accountType = payload;
    }),
};

export default user;
